import { legacy_createStore as createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers';
import { loadPersistedStore, persistStore } from '#/utils/persistStore';
import { throttle } from 'lodash';

const persistedStore = loadPersistedStore();

const store = createStore(rootReducer, persistedStore, composeWithDevTools());

store.subscribe(
  throttle(() => {
    persistStore({
      profile: store.getState().profile,
    });
  }, 1000)
);

export type TRootState = ReturnType<typeof store.getState>;

export type TAppDispatch = typeof store.dispatch;

export default store;
